/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SpeechModel } from '../models/SpeechModel';
import type { SpeechModelListe } from '../models/SpeechModelListe';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SpeechModelService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Liste der verfügbaren Speech Modelle
   * Gibt eine Liste aller verfügbaren Speech Modelle zurück
   * @returns SpeechModelListe Liste der Speech Modelle
   * @throws ApiError
   */
  public getSpeechModelListe(): CancelablePromise<SpeechModelListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/speech-models',
      errors: {
        401: `Unauthorized for this request (getSpeechModelListe)`,
        403: `Forbidden for this request (getSpeechModelListe)`,
      },
    });
  }

  /**
   * Details eines Speech Modells
   * Gibt die Details eines spezifischen Speech Modells zurück
   * @returns SpeechModel Details des Speech Modells
   * @throws ApiError
   */
  public getSpeechModel({
    speechModel,
  }: {
    /**
     * Eindeutige ID des Speech Modells
     */
    speechModel: string,
  }): CancelablePromise<SpeechModel> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/speech-models/{speechModel}',
      path: {
        'speechModel': speechModel,
      },
      errors: {
        401: `Unauthorized for this request (getSpeechModel)`,
        403: `Forbidden for this request (getSpeechModel)`,
        404: `Not Found`,
      },
    });
  }

}
